import { render } from "./DocumentListItem.vue?vue&type=template&id=398c1c66&scoped=true"
import script from "./DocumentListItem.vue?vue&type=script&lang=js"
export * from "./DocumentListItem.vue?vue&type=script&lang=js"

import "./DocumentListItem.vue?vue&type=style&index=0&id=398c1c66&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398c1c66"]])

export default __exports__